import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateIntegrationOptionValueV3 = OpalApi<
  'UpdateIntegrationOptionValueV3',
  200
>

export const updateIntegrationOptionValue: UpdateIntegrationOptionValueV3 =
  async (args = {}) => {
    const id = args.params?.path.integration_option_value_id

    if (typeof id !== 'string') {
      throw new Error('Must supply a valid integration_option_value_id.')
    }

    const url = new URL(
      `/v3/integration_option_values/${id}`,
      window.location.origin
    )

    return HttpClient()
      .patch(url.toString(), args.requestBody)
      .then((res) => res.data)
  }
